import {Indicator} from '@mantine/core'
import {useDisclosure} from '@mantine/hooks'
import {IconAdjustmentsHorizontal} from '@tabler/icons-react'

import SidebarNavLink from '../nav/nav-link'
import {useScenarioPlanning} from './scenario-context'
import {ScenarioModal} from './scenario-modal'

type ScenarioPlanningTriggerProps = {
    narrow: boolean
    useRfmForEngagement: boolean
}

/** Sidebar control (expanded button or collapsed icon) that opens `ScenarioModal` for admins. */
export function ScenarioPlanningTrigger({
    narrow,
    useRfmForEngagement,
}: ScenarioPlanningTriggerProps) {
    const [isOpen, {open, close}] = useDisclosure(false)
    const {appliedScenario, applyScenario, resetToDefaults, hasOverrides} = useScenarioPlanning()

    return (
        <>
            <Indicator
                inline
                disabled={!hasOverrides}
                color="green"
                size={8}
                offset={narrow ? 4 : 6}
            >
                <SidebarNavLink
                    label="Scenario Planning"
                    icon={<IconAdjustmentsHorizontal size={18} />}
                    onClick={open}
                    narrow={narrow}
                    active={hasOverrides}
                />
            </Indicator>
            <ScenarioModal
                opened={isOpen}
                onClose={close}
                useRfmForEngagement={useRfmForEngagement}
                appliedScenario={appliedScenario}
                onApply={applyScenario}
                onReset={resetToDefaults}
                hasOverrides={hasOverrides}
            />
        </>
    )
}
